<template>
  <app-logged id="UsuariosCreate">
    <v-flex
      :sm6="!!usuario.id"
      xs12
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            :class-widget="(!!usuario.id) ? 'xs12' : 'md6 offset-md3 sm8 offset-sm2 xs12'"
          >
            <div slot="widget-content">
              <AppFormHeader
                title="Informações de usuário"
                icon="home"
              />
              <validation-provider
                name="nome"
                rules="required|alpha_spaces"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="usuario.nome"
                  label="Nome"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="e-mail"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="usuario.email"
                  label="E-mail"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <!-- <validation-provider
                name="regra de acesso"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :items="regras"
                  v-model="usuario.regra_acesso"
                  label="Regra de acesso"
                  :return-object="false"
                  item-value="id"
                  item-text="name"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider> -->
              <AppPasswordConfirmation
                :entity.sync="usuario"
                :force="!!!usuario.id"
              />
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="usuario.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
    <v-flex
      v-if="!!usuario.id"
      sm6
      xs12
    >
      <AppUsuarioRegras />
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
import AppFormHeader from '@/components/AppFormHeader'
import AppPasswordConfirmation from '@/components/AppPasswordConfirmation'
import AppUsuarioRegras from '@/components/AppUsuarioRegras'
export default {
  name: 'UsuariosCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppFormHeader,
    AppPasswordConfirmation,
    AppUsuarioRegras,
    AppButton
  },
  data () {
    return {
      confirmacao: ''
    }
  },
  computed: {
    ...mapGetters(['cidade', 'regras']),
    usuario: {
      get () {
        return this.$store.getters.usuario
      },
      set (val) {
        return this.$store.commit('setUsuario', val)
      }
    }
  },
  methods: {
    ...mapActions(['postSaveUsuario', 'deleteUsuario']),
    goToUsuarioIndex () {
      this.$router.push({
        name: 'usuarios-index'
      })
    },
    remove () {
      if (confirm('Confirme a exclusão desta usuario.')) {
        this.deleteUsuario().then(res => {
          this.goToUsuarioIndex()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveUsuario().then(res => {
            this.goToUsuarioIndex()
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
